/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The `state` represents the operational status of an issued card. A card can only approve incoming authorizations if it is in an active state.
 *
 * @remarks
 *
 * - `active`: The card is operational and approves authorizations. Generally becomes active shortly after card creation.
 * - `inactive`: The card cannot approve authorizations. This is currently a temporary state assigned post-creation during the activation process.
 * - `closed`: The card is permanently deactivated and cannot approve authorizations. A card can be closed by request or when it expires.
 * - `pending-verification`: Awaiting additional authorized user verification before the card can be activated.
 */
export const IssuedCardState = {
  Active: "active",
  Inactive: "inactive",
  PendingVerification: "pending-verification",
  Closed: "closed",
} as const;
/**
 * The `state` represents the operational status of an issued card. A card can only approve incoming authorizations if it is in an active state.
 *
 * @remarks
 *
 * - `active`: The card is operational and approves authorizations. Generally becomes active shortly after card creation.
 * - `inactive`: The card cannot approve authorizations. This is currently a temporary state assigned post-creation during the activation process.
 * - `closed`: The card is permanently deactivated and cannot approve authorizations. A card can be closed by request or when it expires.
 * - `pending-verification`: Awaiting additional authorized user verification before the card can be activated.
 */
export type IssuedCardState = ClosedEnum<typeof IssuedCardState>;

/** @internal */
export const IssuedCardState$inboundSchema: z.ZodNativeEnum<
  typeof IssuedCardState
> = z.nativeEnum(IssuedCardState);
/** @internal */
export const IssuedCardState$outboundSchema: z.ZodNativeEnum<
  typeof IssuedCardState
> = IssuedCardState$inboundSchema;
